import React, { useState, useEffect } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    TextField, 
    FormControlLabel, 
    Switch, 
    CircularProgress, 
    Grid 
} from '@mui/material';
import { RestaurantService } from '../../../api/services/restaurantService';
import { toast } from '../../../utils/toast';

export default function EditMenuCategoryModal({ open, onClose, category, onCategoryUpdated }) {
    const [isUpdating, setIsUpdating] = useState(false);
    const [form, setForm] = useState({
        name: '',
        isActive: true
    });

    useEffect(() => {
        if (category && open) {
            setForm({
                name: category.name || '',
                isActive: Boolean(category.isActive)
            });
        }
    }, [category, open]);

    const handleClose = () => {
        if (isUpdating) return;
        onClose();
    };

    const handleSubmit = async () => {
        if (!category?.id) return;
        
        setIsUpdating(true);
        try {
            await RestaurantService.updateMenuCategory(category.id, {
                name: form.name,
                isActive: Boolean(form.isActive)
            });
            toast.success('Menu category updated successfully');
            handleClose();
            if (onCategoryUpdated) {
                onCategoryUpdated();
            }
        } catch (error) {
            console.error('Failed to update menu category:', error);
            // Validation rejections/errors handled safely by global interceptor
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle fontWeight="bold">Update Category Profile</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Category Name"
                            placeholder="e.g., Breakfast & Brunch"
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                            disabled={isUpdating}
                            autoFocus
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.isActive}
                                    onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
                                    color="success"
                                    disabled={isUpdating}
                                />
                            }
                            label="Active Visibility (Publish/Hide)"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button 
                    onClick={handleClose} 
                    disabled={isUpdating} 
                    color="inherit"
                >
                    Cancel
                </Button>
                <Button 
                    variant="contained" 
                    onClick={handleSubmit}
                    disabled={isUpdating || !form.name.trim()}
                    startIcon={isUpdating ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {isUpdating ? 'Saving...' : 'Update Category'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
